import * as React from 'react';
import { ProductRelationTypes, Units } from '../../common/enums';
import { ProductModel } from '../../models/product/productModel';
import { TextField, Button } from '@material-ui/core';
import Translate from '../../common/functions/translate';
import ProductService from '../../services/productService';
import Spinner from '../../common/components/spinner/spinner';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Snackbar from "../../common/components/snackbar/snackbar";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DropdownModel } from '../../models/dropdownModel';
import { DataTable } from 'primereact/datatable';
import { ProductToProductModel } from '../../models/product/productToProductModel';
import { Column } from 'primereact/column';
import { ProductRelationFilterModel } from '../../models/product/productRelationFilterModel';
import { Button as PRButton } from "primereact/button";
import { getEnumLabel } from '../../common/functions/helperFunctions';
import { CategoryModel } from '../../models/category';
import CategoryService from '../../services/categoriesService';

interface IProps {
    currentProduct: ProductModel
    productRelationType: ProductRelationTypes;
    selectedCategoryTypeId: number;
}

interface IState {
    isLoading: boolean;
    searchTerm: string;
    products: Array<ProductModel>
    productsDropdown: Array<DropdownModel>;
    currentSelection: DropdownModel | null;
    currentProduct: ProductModel;
    errorMessage: string;
    categories: Array<CategoryModel>;
    mainCategoryTypeId: number;
}

class AddEditProductRelationComponent extends React.Component<IProps, IState> {
    snackbar: any;
    productService = new ProductService();
    categoriesService = new CategoryService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            searchTerm: '',
            products: new Array<ProductModel>(),
            productsDropdown: new Array<DropdownModel>(),
            currentSelection: null,
            currentProduct: this.props.currentProduct,
            errorMessage: '',
            categories: new Array<CategoryModel>(0),
            mainCategoryTypeId: 0,
        };
    }

    componentDidMount() {
        this.getCategories();
    }

    getCategories = () => {
        this.setState({
            isLoading: true
        });

        this.categoriesService.getAllCategories().then(
            (categories: any) => {
                this.setState({
                    categories,
                    isLoading: false
                }, () => this.getMainCategoryTypeId());
            }).catch(error => {
                this.setState({
                    isLoading: false
                });
            })
    }

    getMainCategoryTypeId = () => {
        const { categories, currentProduct } = this.state;
        let mainCategoryTypeId = 0;

        if (categories.length > 0) {
            let currentProductCategory = categories.find(c => c.id === currentProduct.categoryId);
            mainCategoryTypeId = this.getCategoryMainCategoryType(currentProductCategory);
        }

        this.setState({
            mainCategoryTypeId
        });
    }

    getCategoryMainCategoryType = (category: CategoryModel | undefined): number => {
        const { categories } = this.state;
        let mainCategoryTypeId = 0;

        if (category) {
            if (!category.parentId) {
                mainCategoryTypeId = category.categoryTypeId
            } else {
                let parentId = category.parentId;
                while (parentId !== 0) {
                    // eslint-disable-next-line
                    let currCategory = categories.find(c => c.id === parentId);

                    if (currCategory) {
                        parentId = currCategory.parentId;
                        mainCategoryTypeId = currCategory.categoryTypeId;
                    } else {
                        parentId = 0;
                    }
                }
            }
        }

        return mainCategoryTypeId;
    }

    filterProducts = (products: Array<ProductModel>): Array<ProductModel> => {
        const { categories, mainCategoryTypeId } = this.state;
        let filteredProducts = new Array<ProductModel>(0);

        if (products) {
            products.forEach(product => {
                let category = categories.find(c => c.id === product.categoryId);

                if (category) {
                    let productMainCategoryTypeId = this.getCategoryMainCategoryType(category);

                    if (productMainCategoryTypeId === 0 || productMainCategoryTypeId === mainCategoryTypeId) {
                        filteredProducts.push(product);
                    }
                }
            });
        }

        return filteredProducts;
    }

    getProducts = () => {
        const { products } = this.state;

        if (products && products.length > 0) {
            return;
        }

        console.log(products);

        this.setState({
            products: [],
            productsDropdown: [],
            currentSelection: null
        });

        this.setState({
            isLoading: true
        });

        let filter = new ProductRelationFilterModel();
        filter.selectedCategoryTypeId = this.props.selectedCategoryTypeId;

        this.productService.getFilteredProducts(filter).then(
            (data: Array<ProductModel>) => {
                let filteredProducts = this.filterProducts(data);

                let productsDropdown = new Array<DropdownModel>(0);
                filteredProducts.forEach(r => productsDropdown.push({ label: r.articleNumber + ' | ' + r.article, value: r.productId }));
                this.setState({
                    isLoading: false,
                    products: filteredProducts,
                    productsDropdown: productsDropdown
                });
            })
            .catch(
                error => {
                    this.setState({
                        isLoading: false,
                    });
                    this.snackbar.show({ severity: 'error', summary: error.message });
                }
            )
    }


    handleChange = (key, value) => {
        // const installationActivity: InstallationActivityModel = { ...this.state.installationActivity };
        // installationActivity[key] = value;
        // this.setState({ installationActivity: { ...installationActivity } });
    };

    handleAutocompleteSelection = (e, value) => {
        this.setState({
            currentSelection: value
        });
    }

    handleAutocompleteKeyUp = (value) => {
        // this.setState({
        //     searchTerm: value
        // }, () => this.searchProducts())
    }

    handleAddButton = () => {
        this.setState({ errorMessage: '' });

        const { currentSelection, products, currentProduct } = this.state;

        let selectedProduct = products.find((product) => product.productId === (currentSelection as DropdownModel).value);

        if (selectedProduct) {
            if (currentProduct.relatedProducts) {
                if (currentProduct.relatedProducts.find(p => p.relatedProductId === (selectedProduct as ProductModel).productId && p.relationType === this.props.productRelationType)) {
                    this.setState({
                        errorMessage: Translate('Product is already added')
                    })

                    return;
                }
            }

            this.setState({
                isLoading: true
            });

            // we do this get to get the product with all its relations!
            this.productService.getProduct(selectedProduct.productId).then(
                (product) => {
                    this.addRelatedProduct(product);
                }
            ).catch(error => {
                this.addRelatedProduct(selectedProduct!);
                console.log(error);
            })
        }
    }

    addRelatedProduct = (selectedProduct: ProductModel) => {
        const { currentProduct } = this.state;

        let relatedProduct = new ProductToProductModel();
        relatedProduct.count = 1;
        relatedProduct.productId = currentProduct.productId;
        relatedProduct.relatedProductId = selectedProduct.productId;
        relatedProduct.relatedProduct = selectedProduct;
        relatedProduct.relationType = this.props.productRelationType;

        if (!currentProduct.relatedProducts) {
            currentProduct.relatedProducts = new Array<ProductToProductModel>();
        }

        currentProduct.relatedProducts.push(relatedProduct);

        this.setState({
            isLoading: false,
            currentProduct,
            currentSelection: null,
            // products: [],
            searchTerm: '',
            // productsDropdown: []
        });
    }

    handleQtyChanged = (product: ProductModel, qty) => {
        let currentProduct = { ...this.state.currentProduct }
        let relatedProducts = [...currentProduct.relatedProducts];

        let relatedProduct = relatedProducts.find(p => p.relatedProductId === product.productId);

        if (relatedProduct) {
            relatedProduct.count = qty;
        }

        currentProduct.relatedProducts = relatedProducts;

        this.setState({
            currentProduct
        });
    }

    handleRelatedProductDeleteClick = (column) => {
        var productId = column.rowData.relatedProductId;

        let currentProduct = this.state.currentProduct;
        let relatedProducts = [...currentProduct.relatedProducts];

        let relatedProductToRemove = relatedProducts.find(el => el.relatedProductId === productId && el.relationType === this.props.productRelationType);

        if (relatedProductToRemove) {
            let index = relatedProducts.indexOf(relatedProductToRemove);
            relatedProducts.splice(index, 1);
        }

        currentProduct.relatedProducts = relatedProducts;

        this.setState({
            currentProduct
        });
    }

    getProductRelations = (relatedProducts: Array<ProductToProductModel>, inner: boolean) => {

        if (relatedProducts) {
            let html = '<div style="margin-left: 15px">'
            relatedProducts.forEach(relatedProduct => {
                let rp = relatedProduct.relatedProduct;

                html += `<div style="${!inner ? 'margin-top: 5px' : null}">&bull; ${rp.articleNumber} ${rp.article} (${relatedProduct.count} ${getEnumLabel(rp.unitId, Units, true)})</div>`;

                if (rp.relatedProducts) {
                    html += this.getProductRelations(rp.relatedProducts, true);
                }
            });
            html += '</div>';

            return html;
        }

        return '';
    }

    public render() {

        const { isLoading, productsDropdown, currentSelection, currentProduct, errorMessage } = this.state;

        let relatedProducts = new Array<ProductToProductModel>();

        if (currentProduct.relatedProducts && currentProduct.relatedProducts.length > 0) {
            relatedProducts = currentProduct.relatedProducts.filter(p => p.relationType === this.props.productRelationType);
        }

        return (
            <div>
                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />
                {errorMessage ? <AlertMessage type='danger'>{this.state.errorMessage}</AlertMessage> : null}
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                    <div style={{ width: '100%', marginRight: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Autocomplete
                                style={{ width: "100%", marginRight: 5 }}
                                onOpen={() => this.getProducts()}
                                options={productsDropdown}
                                getOptionLabel={option => option.label}
                                value={currentSelection}
                                onChange={(e, newValue) => this.handleAutocompleteSelection(e, newValue)}
                                noOptionsText={Translate('No records found')}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label={Translate('Article')}
                                        placeholder={Translate('Article search')}
                                        fullWidth
                                    />
                                )}
                            />
                            <div style={{}}>
                                <Button onClick={(e) => this.handleAddButton()}
                                    color="primary"
                                    variant="contained"
                                    style={{ marginTop: 10 }}
                                    disabled={currentSelection === null}>
                                    {Translate("Add")}
                                </Button>
                            </div>
                        </div>

                        {relatedProducts.length > 0
                            ? <DataTable
                                value={relatedProducts}
                                dataKey='id'
                                style={{ marginTop: 20 }}
                            >
                                <Column
                                    field="articleNumber"
                                    header={Translate("Article number")}
                                    style={{ textAlign: "center", width: '100px' }}
                                    body={(rowData, column) =>
                                        <div>
                                            {rowData.relatedProduct.articleNumber}
                                        </div>
                                    }
                                />
                                <Column
                                    field="article"
                                    header={Translate("Article")}
                                    body={(rowData, column) =>
                                        <div>
                                            {rowData.relatedProduct.relatedProducts && rowData.relatedProduct.relatedProducts.length > 0
                                                ? <strong>{rowData.relatedProduct.article}</strong>
                                                : <>{rowData.relatedProduct.article}</>}
                                            <div dangerouslySetInnerHTML={{ __html: this.getProductRelations(rowData.relatedProduct.relatedProducts, false) }} />
                                        </div>
                                    }
                                />
                                <Column
                                    header={Translate("UnitShort")}
                                    style={{ textAlign: "center", width: '100px' }}
                                    body={(rowData, column) =>
                                        <div style={{ textAlign: 'center' }}>
                                            <span>{getEnumLabel(rowData.relatedProduct.unitId, Units, true)}</span>
                                        </div>
                                    }
                                />
                                <Column
                                    field="count"
                                    header={Translate("Qty")}
                                    style={{ textAlign: "center", width: '100px' }}
                                    body={(rowData, column) =>
                                        <div style={{ textAlign: 'center' }}>
                                            <TextField
                                                onChange={(e) => this.handleQtyChanged(rowData.relatedProduct, e.target['value'])}
                                                value={rowData.count}
                                                type='number'
                                            />
                                        </div>
                                    }
                                />
                                <Column
                                    field="price"
                                    header={Translate("Single price")}
                                    style={{ textAlign: "center", width: '100px' }}
                                    body={(rowData, column) =>
                                        <div>
                                            {rowData.relatedProduct.price.toFixed(2)}
                                        </div>
                                    }
                                />

                                <Column
                                    header=''
                                    style={{ textAlign: "center", width: '70px' }}
                                    body={(rowData, column) =>
                                        <div>
                                            <PRButton
                                                type="button"
                                                icon="pi pi-trash"
                                                className="p-button-danger"
                                                tooltip={Translate("Delete")}
                                                tooltipOptions={{ position: 'top' }}
                                                onClick={() => this.handleRelatedProductDeleteClick(column)}
                                            />
                                        </div>
                                    }
                                />
                            </DataTable>
                            : <div style={{ marginTop: 50 }}>
                                {this.props.productRelationType === ProductRelationTypes.InstallationActivity
                                    ? Translate('There are no installation activities added')
                                    : null
                                }
                                {this.props.productRelationType === ProductRelationTypes.Fastener
                                    ? Translate('There are no fasteners added')
                                    : null
                                }
                                {this.props.productRelationType === ProductRelationTypes.Package
                                    ? Translate('No products added to the package')
                                    : null
                                }
                                {this.props.productRelationType === ProductRelationTypes.Labor
                                    ? Translate('No labor added in service')
                                    : null
                                }
                            </div>}
                    </div>
                </div>
            </div >

        )

    }
}

export default AddEditProductRelationComponent;